import { render, staticRenderFns } from "./MakeAudio.vue?vue&type=template&id=5066da00&scoped=true"
import script from "./MakeAudio.vue?vue&type=script&lang=js"
export * from "./MakeAudio.vue?vue&type=script&lang=js"
import style0 from "./MakeAudio.vue?vue&type=style&index=0&id=5066da00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066da00",
  null
  
)

export default component.exports